export default __webpack_public_path__ + "static/media/amenities_image.e14a1a5a.png";